import React, { useState, useEffect } from "react";
import {
  Radio, Input, Tooltip,
  // DatePicker, Checkbox, Upload, Button,
  Select, Tag,
} from "antd";
import {
  HistoryOutlined,
  // PaperClipOutlined
} from "@ant-design/icons";
// import dayjs from "dayjs";
// import { toast } from "react-toastify";
// import RcaDocuments from "../../RcaDocuments";
// import {
//   RCA_UPLOAD_ACCEPT,
//   uploadRcaDocument,
//   validateRcaDocumentFile,
// } from "../../utils";
import "./QCFormSection.css";

const { TextArea } = Input;

const QCFormSection = ({
  qcOptions,
  selectedResult,
  onQCOptionChange,
  note,
  onNoteChange,
  retestComment,
  onRetestCommentChange,
  textareaRow,
  generateRetestDisableReason,
  genistaId,
  assignedTo,
  testName,
  pendingForText,
  readOnly = false,
  hasActiveRca = false,
  // expectedCompleteDate,
  // onExpectedCompleteDateChange,
  // pendingRcaS3Keys = [],
  // onPendingRcaS3KeysChange,
  // completeRcaChecked = false,
  // onCompleteRcaCheckedChange,
  // tisPk,
  onRcaHistoryClick,
  // rcaViewOnly = false,
  // displayRcaS3Keys = [],
  retestReasonOptions,
  retestReasonsLoading,
  retestReason,
  onRetestReasonChange,
}) => {
  const [enhancedQcOptions, setEnhancedQcOptions] = useState([]);
  // const [uploadingCount, setUploadingCount] = useState(0);
  // const uploading = uploadingCount > 0;
  // Do not disable the whole Mark Sample group for Active RCA — only the RCA radio.
  // Pass / Hold stay enabled; Create Retest still uses generateRetestDisableReason (Sample Prep).
  // RCA stays selected+disabled when Active (indicator only; create/edit via Data Ops).
  const markSampleDisabled = readOnly;
  // const rcaFieldsLocked = readOnly || rcaViewOnly;
  // const requiresAttachedDocumentForComplete = completeRcaChecked;

  useEffect(() => {
    setEnhancedQcOptions(qcOptions.map((item) => {
      if (item.value === "4") {
        const rcaLabel = (
          <span className="QCFormSection__RcaOptionLabel">
            <span>{item.label}</span>
            {typeof onRcaHistoryClick === "function" && (
              <Tooltip title="RCA History" placement="top">
                <HistoryOutlined
                  className="QCFormSection__RcaHistoryIcon"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onRcaHistoryClick();
                  }}
                />
              </Tooltip>
            )}
            {hasActiveRca && (
              <Tag color="processing" className="QCFormSection__RcaActiveTag">
                Active
              </Tag>
            )}
          </span>
        );
        return {
          ...item,
          disabled: true,
          label: (
            <Tooltip title="RCA is managed by Data Ops" placement="top">
              <span className="QCFormSection__DisabledOptionLabel">{rcaLabel}</span>
            </Tooltip>
          ),
        };
      }
      if (item.value !== "3" || !generateRetestDisableReason) {
        return item;
      }
      return {
        ...item,
        disabled: true,
        label: (
          <Tooltip title={generateRetestDisableReason} placement="top">
            <span className="QCFormSection__DisabledOptionLabel">{item.label}</span>
          </Tooltip>
        ),
      };
    }));
  }, [qcOptions, generateRetestDisableReason, hasActiveRca, onRcaHistoryClick]);

  // const beforeUpload = (file) => {
  //   const validation = validateRcaDocumentFile(file);
  //   if (!validation.valid) {
  //     toast.error(validation.message);
  //     return Upload.LIST_IGNORE;
  //   }
  //   return true;
  // };

  // const customUpload = async ({ file, onSuccess, onError }) => {
  //   setUploadingCount((count) => count + 1);
  //   const result = await uploadRcaDocument(file, tisPk);
  //   setUploadingCount((count) => Math.max(0, count - 1));
  //   if (!result.success) {
  //     toast.error(result.message);
  //     if (onError) {
  //       onError(new Error(result.message));
  //     }
  //     return;
  //   }
  //   // Functional update so parallel multi-file uploads don't overwrite each other.
  //   onPendingRcaS3KeysChange((prevKeys = []) => [...prevKeys, result.path]);
  //   if (onSuccess) {
  //     onSuccess(result);
  //   }
  // };

  // const removePendingRcaDocument = (s3Key) => {
  //   onPendingRcaS3KeysChange((prevKeys = []) => (
  //     prevKeys.filter((pendingKey) => pendingKey !== s3Key)
  //   ));
  // };

  return (
    <>
      {(assignedTo || genistaId != null || testName || pendingForText) && (
        <div className="MarkSampleQCModal__HeaderMeta">
          {assignedTo && (
            <span>
              Assigned to:
              {" "}
              {assignedTo}
            </span>
          )}
          {assignedTo && genistaId != null && (
            <span className="MarkSampleQCModal__HeaderMetaSeparator">|</span>
          )}
          {genistaId != null && (
            <span>
              Genista ID:
              {" "}
              {genistaId}
            </span>
          )}
          {genistaId != null && testName && (
            <span className="MarkSampleQCModal__HeaderMetaSeparator">|</span>
          )}
          {testName && (
            <span>
              Test:
              {" "}
              {testName}
            </span>
          )}
          {pendingForText && (
            <>
              <span className="MarkSampleQCModal__HeaderMetaSeparator">|</span>
              <span>
                Pending for:
                {" "}
                {pendingForText}
              </span>
            </>
          )}
        </div>
      )}

      <div className="MarkSampleQCModal__InputSection">
        <label className="MarkSampleQCModal__Label MarkSampleQCModal__Label--block">
          Mark Sample
        </label>
        <Radio.Group
          block
          options={enhancedQcOptions}
          value={selectedResult}
          onChange={markSampleDisabled ? undefined : onQCOptionChange}
          disabled={markSampleDisabled}
        />
      </div>

      {/*
        Data Ops owns RCA create/edit from QC Dashboard.
        Hide Expected RCA Completion Date + attachments while RCA is selected
        (option stays disabled with tooltip). Keeping block commented for future revert.
      {selectedResult === "4" && (
        <>
          <div className="MarkSampleQCModal__InputSection">
            <label className="MarkSampleQCModal__Label MarkSampleQCModal__Label--block">
              Expected RCA Completion Date
              {!rcaFieldsLocked && <span className="QCFormSection__RequiredMark"> *</span>}
            </label>
            <div className="QCFormSection__RcaActionsRow">
              <DatePicker
                className="QCFormSection__ExpectedCompleteDate"
                value={expectedCompleteDate}
                onChange={rcaFieldsLocked ? undefined : onExpectedCompleteDateChange}
                disabled={rcaFieldsLocked}
                format="MM/DD/YYYY"
                allowClear={false}
                disabledDate={(current) => current && current.isBefore(dayjs(), "day")}
              />
              {!rcaFieldsLocked && (
                <>
                  <Upload
                    accept={RCA_UPLOAD_ACCEPT}
                    multiple
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    customRequest={customUpload}
                    disabled={uploading}
                  >
                    <Button
                      type="default"
                      icon={<PaperClipOutlined />}
                      loading={uploading}
                    >
                      Attach Document
                      {requiresAttachedDocumentForComplete && (
                        <span className="QCFormSection__RequiredMark"> *</span>
                      )}
                    </Button>
                  </Upload>
                  <Checkbox
                    checked={completeRcaChecked}
                    onChange={(event) => onCompleteRcaCheckedChange(event.target.checked)}
                  >
                    Mark RCA as Complete
                  </Checkbox>
                </>
              )}
            </div>
          </div>

          {(rcaFieldsLocked ? displayRcaS3Keys.length > 0 : pendingRcaS3Keys.length > 0) && (
            <div className="MarkSampleQCModal__InputSection">
              <div className="QCFormSection__RcaSectionTitle">Attached Documents</div>
              <RcaDocuments
                s3Keys={rcaFieldsLocked ? displayRcaS3Keys : pendingRcaS3Keys}
                removableS3Keys={rcaFieldsLocked ? [] : pendingRcaS3Keys}
                onRemove={rcaFieldsLocked ? undefined : removePendingRcaDocument}
              />
            </div>
          )}
        </>
      )}
      */}

      {selectedResult === "3" && (
        <div className="MarkSampleQCModal__InputSection">
          <label className="MarkSampleQCModal__Label MarkSampleQCModal__Label--block">
            Retest Reason
          </label>
          <div className="QCFormSection__RetestReasonWrapper">
            <Select
              options={retestReasonOptions}
              value={retestReason || undefined}
              onChange={(value) => onRetestReasonChange(value ?? "")}
              loading={retestReasonsLoading}
              disabled={readOnly || retestReasonsLoading}
              allowClear
              showSearch
              filterOption={(inputValue, option) => (
                option.label?.toLowerCase().includes(inputValue?.toLowerCase())
              )}
              placeholder="Select a retest reason"
              notFoundContent="No retest reasons available"
              className="QCFormSection__RetestReasonSelect"
              listHeight={400}
            />
          </div>
        </div>
      )}

      {selectedResult === "3" && (
        <div className="QCFormSection__RetestFieldsRow">
          <div className="MarkSampleQCModal__InputSection QCFormSection__RetestFieldCol">
            <label className="MarkSampleQCModal__Label MarkSampleQCModal__Label--block">
              Sample Notes
            </label>
            <TextArea
              autoSize={{ minRows: textareaRow, maxRows: textareaRow }}
              value={retestComment}
              onChange={readOnly ? undefined : onRetestCommentChange}
              readOnly={readOnly}
              disabled={readOnly}
              count={{
                show: true,
                max: 500,
              }}
              placeholder="Enter sample notes..."
            />
          </div>
          <div className="MarkSampleQCModal__InputSection QCFormSection__RetestFieldCol">
            <label className="MarkSampleQCModal__Label MarkSampleQCModal__Label--block">
              QC Reason
            </label>
            <TextArea
              autoSize={{ minRows: textareaRow, maxRows: textareaRow }}
              value={note}
              onChange={readOnly ? undefined : onNoteChange}
              readOnly={readOnly}
              disabled={readOnly}
              count={{
                show: true,
                max: 500,
              }}
              placeholder="Enter QC Message..."
            />
          </div>
        </div>
      )}

      {selectedResult !== "3" && (
        <div className="MarkSampleQCModal__InputSection">
          <label className="MarkSampleQCModal__Label MarkSampleQCModal__Label--block">
            QC Reason
          </label>
          <TextArea
            autoSize={{ minRows: textareaRow, maxRows: textareaRow }}
            value={note}
            onChange={readOnly ? undefined : onNoteChange}
            readOnly={readOnly}
            disabled={readOnly}
            count={{
              show: true,
              max: 500,
            }}
            placeholder="Enter QC Message..."
          />
        </div>
      )}
    </>
  );
};

export default QCFormSection;
